import { render, staticRenderFns } from "./InboundStatistics.vue?vue&type=template&id=1baf0504&scoped=true&"
import script from "./InboundStatistics.vue?vue&type=script&lang=js&"
export * from "./InboundStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf0504",
  null
  
)

export default component.exports